import firebase from 'firebase/app';
import 'firebase/analytics';

import firebaseConfig from './firebaseConfig';
import { APP_VERSION } from '../../constants/version';

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const firebaseAnalytics = firebase.analytics();

// Set app version as user property for tracking
firebaseAnalytics.setUserProperties({
  app_version: APP_VERSION,
  platform: 'web',
});
